"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { startTransition, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ErrorPageLayout } from "@/components/error-page-layout";
import { Text } from "@/components/text";
import { INTERNAL_LINKS } from "@/lib/helpers/urls";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <ErrorPageLayout>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <Text size="3xl" as="h1">
            Something went wrong
          </Text>
          <Text>An unexpected error occurred. Our team has been notified.</Text>
        </div>
        <div className="flex gap-2">
          <Button
            className="w-fit"
            variant="primary"
            onClick={() => {
              startTransition(() => {
                router.refresh();
                reset();
              });
            }}
          >
            Try Again
          </Button>
          <Button className="w-fit" variant="outline" asChild>
            <Link href={INTERNAL_LINKS.HOME}>Go Home</Link>
          </Button>
        </div>
      </div>
    </ErrorPageLayout>
  );
}
